import React, { ReactNode } from 'react'
import invariant from 'tiny-invariant'
import { typeValidator } from '@chilipiper/utils'
import { Box } from '../../../core-components'
import { PositioningProps } from '../../types'
import { SectionHeader } from '../section-header/SectionHeader'

type Props = {
  children: ReactNode
  variant?: 'rounded' | 'nested'
  'data-test-id'?: string
  header?: ReactNode
} & PositioningProps

export const Section = ({
  variant = 'rounded',
  'data-test-id': dataTestId,
  children,
  header,
  ...positioningProps
}: Props) => {
  invariant(
    header === undefined || typeValidator(SectionHeader)(header),
    'header must be a SectionHeader or undefined'
  )
  return (
    <Box
      borderRadius={variant === 'rounded' ? 12 : undefined}
      boxShadow={variant === 'rounded' ? 'border/section' : undefined}
      bg={variant === 'rounded' ? 'bg/section' : undefined}
      overflow='hidden'
      data-test-id={dataTestId}
      {...positioningProps}
    >
      {header}
      {children}
    </Box>
  )
}
